import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, resolveComponent as _resolveComponent, isRef as _isRef } from "vue";
const _hoisted_1 = {
    class: "dialog-lightbox__container w-full flex"
};
const _hoisted_2 = {
    class: "swiper-lightbox__item w-full h-full flex justify-center"
};
const _hoisted_3 = {
    key: 0,
    class: "swiper-lightbox__video w-full flex relative rounded-[2rem] overflow-hidden"
};
const _hoisted_4 = [
    "src"
];
const _hoisted_5 = {
    key: 1,
    class: "swiper-lightbox__image w-full h-[40rem] tablet:h-[60rem] flex"
};
const _hoisted_6 = [
    "src",
    "width",
    "height"
];
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Navigation, Pagination } from 'swiper/modules';
import { ref, getCurrentInstance, nextTick } from 'vue';
import { useStore } from 'vuex';
export default {
    __name: 'DialogLightbox',
    setup (__props) {
        const modules = [
            Navigation,
            Pagination
        ];
        const { proxy, appContext } = getCurrentInstance();
        const store = useStore();
        let elSwiper = ref(null); // Zmiana z false na null dla lepszej walidacji
        const onSwiper = (swiper)=>{
            elSwiper.value = swiper;
        };
        let dialogVisible = ref(false);
        let gallery = ref(null);
        let autoplay = ref(0);
        proxy.$emitter.on('dialog_lightbox', (data)=>{
            dialogVisible.value = true;
            const id = data.id;
            const name = data.name;
            const index = data.index;
            gallery.value = store.state.gallery[id][name];
            nextTick(()=>{
                if (elSwiper.value && typeof elSwiper.value.slideTo === 'function') {
                    elSwiper.value.slideTo(index);
                    if (gallery.value[index].video) {
                        autoplay.value = 1;
                    }
                }
            });
        });
        return (_ctx, _cache)=>{
            const _component_el_dialog = _resolveComponent("el-dialog");
            return _openBlock(), _createBlock(_component_el_dialog, {
                modelValue: _unref(dialogVisible),
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>_isRef(dialogVisible) ? dialogVisible.value = $event : dialogVisible = $event),
                width: "1000",
                "modal-class": "dailog-video dialog-lightbox",
                "destroy-on-close": true
            }, {
                default: _withCtx(()=>[
                        _createElementVNode("div", _hoisted_1, [
                            _createVNode(_unref(Swiper), {
                                onSwiper: onSwiper,
                                "slides-per-view": "1",
                                "space-between": 24,
                                pagination: {
                                    clickable: true
                                },
                                navigation: {
                                    nextEl: '.lightbox-swiper-button-next',
                                    prevEl: '.lightbox-swiper-button-prev'
                                },
                                modules: modules,
                                class: "swiper-lightbox !pt-0 flex items-center"
                            }, {
                                default: _withCtx(()=>[
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(gallery), (item, index)=>{
                                            return _openBlock(), _createBlock(_unref(SwiperSlide), {
                                                key: index,
                                                class: "swiper-lightbox__slide"
                                            }, {
                                                default: _withCtx(()=>[
                                                        _createElementVNode("div", _hoisted_2, [
                                                            item.video ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                                                _cache[1] || (_cache[1] = _createElementVNode("div", {
                                                                    style: {
                                                                        "padding": "56.25% 0 0 0",
                                                                        "position": "relative"
                                                                    }
                                                                }, null, -1)),
                                                                _createElementVNode("iframe", {
                                                                    src: item.video + '?autoplay=' + _unref(autoplay) + '&loop=1',
                                                                    frameborder: "0",
                                                                    allow: "autoplay; fullscreen; picture-in-picture",
                                                                    allowfullscreen: "",
                                                                    title: "Sample Video",
                                                                    class: "w-full flex",
                                                                    loading: "lazy"
                                                                }, null, 8, _hoisted_4)
                                                            ])) : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                                                _createElementVNode("img", {
                                                                    src: item.image.url,
                                                                    width: item.image.width,
                                                                    height: item.image.height,
                                                                    loading: "lazy",
                                                                    class: "w-full h-full object-contain"
                                                                }, null, 8, _hoisted_6)
                                                            ]))
                                                        ])
                                                    ]),
                                                _: 2
                                            }, 1024);
                                        }), 128)),
                                        _cache[2] || (_cache[2] = _createElementVNode("div", {
                                            class: "swiper-navigation"
                                        }, [
                                            _createElementVNode("div", {
                                                class: "lightbox-swiper-button-prev swiper-button-prev swiper-button-lightbox top-[unset]"
                                            }),
                                            _createElementVNode("div", {
                                                class: "lightbox-swiper-button-next swiper-button-next swiper-button-lightbox top-[unset]"
                                            })
                                        ], -1))
                                    ]),
                                _: 1
                            })
                        ])
                    ]),
                _: 1
            }, 8, [
                "modelValue"
            ]);
        };
    }
};
